import React from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';
import { InvoicesSection } from '@/components/dashboard/InvoicesSection';

const ACCENT = '#34A853';

/**
 * What a suspended institution's owner/admin sees: the reason, and the
 * Invoices section so dues can be cleared. Everything else is blocked by the
 * backend (tenant_status.py) until Desk Ops reactivates the institution.
 *
 * @param {{ suspension: { message?: string, reason?: string }, onLogout: () => void }} props
 */
export default function SuspendedBillingView({ suspension, onLogout }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC]" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }} data-testid="suspended-billing-view">
      <header className="h-14 bg-white border-b border-gray-200 flex items-center px-6">
        <h1 className="text-base font-semibold text-gray-900">Billing</h1>
        <button onClick={onLogout} className="ml-auto flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800" data-testid="suspended-logout">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </header>
      <main className="p-6 md:p-8 max-w-6xl mx-auto space-y-6">
        <div className="flex gap-3 rounded-2xl border border-red-200 bg-red-50 p-5" role="alert">
          <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-red-800">Your institution's account is suspended</p>
            <p className="text-sm text-red-700 mt-1">
              {suspension?.message || 'Only billing is available until your account is reactivated.'}
            </p>
            {suspension?.reason && (
              <p className="text-xs text-red-700 mt-2"><span className="font-semibold">Reason:</span> {suspension.reason}</p>
            )}
            <p className="text-xs text-red-600/80 mt-2">Clear any pending dues below, or contact Deskey support to reactivate.</p>
          </div>
        </div>
        <InvoicesSection accent={ACCENT} />
      </main>
    </div>
  );
}
